import { Statistic, Card, Typography } from 'antd'

const { Text } = Typography

const StatCard = ({ subtitle, className, ...props }) => (
    <Card
        className={[subtitle ? 'has-subtitle' : '', className].filter(Boolean).join(' ')}
        style={{ width: 315 }}
    >
        <Statistic {...props} />
        {subtitle && <Text>{subtitle}</Text>}
    </Card>
)

export default StatCard
